export default __webpack_public_path__ + "static/media/p-3.46f49f98.png";